// ---- KMT MES/APS mock data ----
export const LOGO = 'https://customer-assets-0z36b82j.emergentagent.net/job_manufacturing-ctrl/artifacts/txkwaaj1_Heading%202.pdf%20%281641%20x%20788%20px%29%20%281080%20x%201080%20px%29%20%282%20x%202%20cm%29.png';
export const APP_NAME = 'KMT FASTENERS Factory Mng';

export const USERS = [];

export const LINES = ['Line A', 'Line B', 'Line C', 'Line D'];
export const MACHINE_TYPES = ['Injection Molder', 'Press Brake', 'Laser Cutter', 'Assembly Robot', 'CNC Mill', 'CNC Lathe'];
export const OPERATORS = ['Amit Sharma', 'Priya Patel', 'Vikram Singh', 'Neha Gupta', 'Suresh Reddy', 'Anita Desai', 'Rahul Verma', 'Kavya Nair'];

const STATUS_POOL = ['RUNNING', 'IDLE', 'PROBLEM', 'STOPPED', 'BREAK'];

function pick(arr, i) { return arr[i % arr.length]; }

// Deterministic 50 machines
export const MACHINES = Array.from({ length: 50 }).map((_, idx) => {
  const n = idx + 2; // start at M02 like source
  const id = 'M' + String(n).padStart(2, '0');
  const type = pick(MACHINE_TYPES, idx);
  const line = pick(LINES, Math.floor(idx / 6));
  let status;
  if (idx === 0) status = 'PROBLEM';
  else if (idx === 2) status = 'PROBLEM';
  else if (idx < 10) status = idx % 3 === 0 ? 'RUNNING' : 'RUNNING';
  else if (idx === 1) status = 'RUNNING';
  else if (idx === 14) status = 'PROBLEM';
  else if (idx === 9) status = 'STOPPED';
  else status = idx % 7 === 0 ? 'PROBLEM' : 'IDLE';
  const assigned = idx < 10 ? pick(OPERATORS, idx) : (idx % 5 === 0 ? pick(OPERATORS, idx) : 'Unassigned');
  const runtime = status === 'IDLE' ? '0m' : (status === 'PROBLEM' && idx === 0 ? '8h 9m' : (idx < 10 ? '10h 16m' : '3h 0m'));
  return {
    id,
    name: `${type.split(' ')[0]} ${type.split(' ')[1] || ''}`.trim() + ' ' + String(n).padStart(2, '0'),
    displayName: idx === 0 ? 'header 2' : `${type} ${String(n).padStart(2, '0')}`,
    type,
    line,
    status,
    operator: assigned,
    runtime: runtime + ' today',
    oee: 60 + ((idx * 7) % 38),
    utilization: 40 + ((idx * 11) % 55),
  };
});

export const STATUS_META = {
  RUNNING: { label: 'Running', cls: 's-running', dot: 'dot-running' },
  STOPPED: { label: 'Stopped', cls: 's-stopped', dot: 'dot-stopped' },
  PROBLEM: { label: 'Problem', cls: 's-problem', dot: 'dot-problem' },
  IDLE: { label: 'Idle', cls: 's-idle', dot: 'dot-idle' },
  BREAK: { label: 'On Break', cls: 's-break', dot: 'dot-break' },
  SETTING: { label: 'Material Setting', cls: 's-setting', dot: 'dot-setting' },
};

const PRODUCTS = ['Steel Bracket A-100', 'Aluminum Frame B-200', 'Housing Cover C-300', 'Precision Shaft D-400', 'Motor Mount E-500', 'Sensor Bracket F-600', 'Turbine Blade G-700', 'Chassis Panel H-800'];
const JOB_STATUS = ['PLANNED', 'IN_PROGRESS', 'COMPLETED', 'ON_HOLD'];

export const JOBS = [
  { code: 'JOB-89088E', product: 'Housing Cover C-300', machine: 'M13', qty: '800/800', start: '8/21, 1:28 AM', end: '8/21, 9:28 AM', status: 'COMPLETED' },
  { code: 'JOB-F2DA63', product: 'Sensor Bracket F-600', machine: 'M36', qty: '200/400', start: '8/21, 5:28 AM', end: '8/21, 5:28 PM', status: 'IN_PROGRESS' },
  { code: 'JOB-FE15D8', product: 'Steel Bracket A-100', machine: 'M02', qty: '250/500', start: '8/21, 1:28 PM', end: '8/21, 9:28 PM', status: 'IN_PROGRESS' },
  { code: 'JOB-D951E7', product: 'Turbine Blade G-700', machine: 'M41', qty: '0/100', start: '8/21, 1:28 PM', end: '8/22, 1:28 PM', status: 'ON_HOLD' },
  { code: 'JOB-E18E8E', product: 'Precision Shaft D-400', machine: 'M19', qty: '0/300', start: '8/21, 5:28 PM', end: '8/22, 1:28 AM', status: 'PLANNED' },
  { code: 'JOB-464DF9', product: 'Aluminum Frame B-200', machine: 'M06', qty: '0/250', start: '8/21, 9:28 PM', end: '8/22, 5:28 AM', status: 'PLANNED' },
  { code: 'JOB-9140E8', product: 'Motor Mount E-500', machine: 'M23', qty: '0/150', start: '8/22, 1:28 AM', end: '8/22, 9:28 AM', status: 'PLANNED' },
  { code: 'JOB-74730E', product: 'Chassis Panel H-800', machine: 'M46', qty: '0/600', start: '8/22, 5:28 AM', end: '8/22, 7:28 PM', status: 'PLANNED' },
];

export const JOB_STATUS_META = {
  PLANNED: { label: 'Planned', cls: 's-planned' },
  IN_PROGRESS: { label: 'In Progress', cls: 's-progress' },
  COMPLETED: { label: 'Completed', cls: 's-completed' },
  ON_HOLD: { label: 'On Hold', cls: 's-hold' },
};

export const GANTT_ROWS = [
  { machine: 'M02', name: 'header 2', product: 'Steel Bracket A-100', offset: 4, span: 30, color: 'var(--kmt-green)' },
  { machine: 'M06', name: 'CNC Mill 06', product: 'Aluminum Frame B-200', offset: 36, span: 30, color: 'var(--kmt-gold)' },
  { machine: 'M13', name: 'CNC Lathe 13', product: 'Housing Cover C-300', offset: 0, span: 30, color: 'var(--kmt-blue)' },
  { machine: 'M19', name: 'CNC Lathe 19', product: 'Precision Shaft D-400', offset: 20, span: 32, color: 'var(--kmt-green)' },
  { machine: 'M23', name: 'Assembly Robot 23', product: 'Motor Mount E-500', offset: 44, span: 30, color: 'var(--kmt-gold)' },
  { machine: 'M36', name: 'Injection Molder 36', product: 'Sensor Bracket F-600', offset: 16, span: 44, color: 'var(--kmt-blue)' },
];

export const LOGS = Array.from({ length: 40 }).map((_, i) => {
  const machine = MACHINES[i % MACHINES.length];
  const events = ['STARTED', 'STOPPED', 'PROBLEM_REPORTED', 'BREAK_STARTED', 'BREAK_ENDED', 'JOB_ASSIGNED', 'STATUS_CHANGED'];
  const ev = events[i % events.length];
  const hh = String(23 - (i % 24)).padStart(2, '0');
  const mm = String((i * 7) % 60).padStart(2, '0');
  return {
    id: 'L' + (1000 + i),
    time: `Aug 21, ${hh}:${mm}`,
    machine: machine.id,
    machineName: machine.displayName,
    event: ev,
    operator: pick(OPERATORS, i),
    detail: ev === 'PROBLEM_REPORTED' ? 'Hydraulic pressure low' : ev === 'JOB_ASSIGNED' ? PRODUCTS[i % PRODUCTS.length] : '—',
  };
});

export const PROBLEMS = [
  { id: 'P-2041', machine: 'M02', name: 'header 2', type: 'Mechanical', severity: 'HIGH', reported: 'Aug 21, 09:14', by: 'Amit Sharma', status: 'OPEN', downtime: '8h 09m', desc: 'Hydraulic pressure dropping below threshold' },
  { id: 'P-2038', machine: 'M04', name: 'Laser Cutter 04', type: 'Calibration', severity: 'MEDIUM', reported: 'Aug 21, 06:02', by: 'Priya Patel', status: 'OPEN', downtime: '3h 00m', desc: 'Beam alignment drift detected' },
  { id: 'P-2035', machine: 'M16', name: 'Laser Cutter 16', type: 'Electrical', severity: 'HIGH', reported: 'Aug 21, 04:48', by: 'System', status: 'IN_PROGRESS', downtime: '2h 20m', desc: 'Servo driver fault code E-42' },
  { id: 'P-2030', machine: 'M09', name: 'Press Brake 09', type: 'Tooling', severity: 'LOW', reported: 'Aug 20, 22:10', by: 'Neha Gupta', status: 'RESOLVED', downtime: '0h 45m', desc: 'Worn die replaced' },
  { id: 'P-2027', machine: 'M23', name: 'Assembly Robot 23', type: 'Software', severity: 'MEDIUM', reported: 'Aug 20, 18:33', by: 'Suresh Reddy', status: 'RESOLVED', downtime: '1h 10m', desc: 'Firmware re-flash required' },
];

export const PROBLEM_STATUS_META = {
  OPEN: { label: 'Open', cls: 's-stopped' },
  IN_PROGRESS: { label: 'In Progress', cls: 's-progress' },
  RESOLVED: { label: 'Resolved', cls: 's-completed' },
};

export const MATERIALS = [
  { code: 'MAT-STL-01', name: 'Steel Sheet 2mm', category: 'Raw Metal', stock: 1240, unit: 'kg', reorder: 500, status: 'OK', supplier: 'TataSteel' },
  { code: 'MAT-ALU-02', name: 'Aluminum Bar 6061', category: 'Raw Metal', stock: 320, unit: 'kg', reorder: 400, status: 'LOW', supplier: 'Hindalco' },
  { code: 'MAT-PLS-03', name: 'ABS Pellets', category: 'Polymer', stock: 80, unit: 'kg', reorder: 150, status: 'CRITICAL', supplier: 'Reliance' },
  { code: 'MAT-BLT-04', name: 'M6 Hex Bolts', category: 'Fasteners', stock: 8600, unit: 'pcs', reorder: 2000, status: 'OK', supplier: 'Unbrako' },
  { code: 'MAT-WLD-05', name: 'MIG Welding Wire', category: 'Consumable', stock: 45, unit: 'spool', reorder: 20, status: 'OK', supplier: 'ESAB' },
  { code: 'MAT-COO-06', name: 'CNC Coolant', category: 'Consumable', stock: 12, unit: 'L', reorder: 40, status: 'CRITICAL', supplier: 'Castrol' },
  { code: 'MAT-CBD-07', name: 'Carbide Inserts', category: 'Tooling', stock: 420, unit: 'pcs', reorder: 100, status: 'OK', supplier: 'Sandvik' },
];

export const MATERIAL_STATUS_META = {
  OK: { label: 'In Stock', cls: 's-completed' },
  LOW: { label: 'Low', cls: 's-hold' },
  CRITICAL: { label: 'Critical', cls: 's-stopped' },
};

export const MATERIAL_SCHEDULE = [
  { id: 'MS-01', material: 'Aluminum Bar 6061', qty: '400 kg', supplier: 'Hindalco', eta: 'Aug 23, 10:00', job: 'JOB-464DF9', status: 'IN_TRANSIT' },
  { id: 'MS-02', material: 'ABS Pellets', qty: '300 kg', supplier: 'Reliance', eta: 'Aug 22, 14:00', job: 'JOB-F2DA63', status: 'SCHEDULED' },
  { id: 'MS-03', material: 'CNC Coolant', qty: '80 L', supplier: 'Castrol', eta: 'Aug 22, 09:00', job: '—', status: 'IN_TRANSIT' },
  { id: 'MS-04', material: 'Steel Sheet 2mm', qty: '1000 kg', supplier: 'TataSteel', eta: 'Aug 24, 08:00', job: 'JOB-FE15D8', status: 'SCHEDULED' },
  { id: 'MS-05', material: 'Carbide Inserts', qty: '200 pcs', supplier: 'Sandvik', eta: 'Aug 21, 18:00', job: '—', status: 'DELIVERED' },
];

export const MS_STATUS_META = {
  SCHEDULED: { label: 'Scheduled', cls: 's-planned' },
  IN_TRANSIT: { label: 'In Transit', cls: 's-progress' },
  DELIVERED: { label: 'Delivered', cls: 's-completed' },
};

export const ASSIGNMENTS = OPERATORS.map((op, i) => ({
  id: 'A' + (i + 1),
  operator: op,
  shift: i % 2 === 0 ? 'Day (06:00-14:00)' : 'Evening (14:00-22:00)',
  line: pick(LINES, i),
  machines: [MACHINES[i].id, MACHINES[(i + 10) % 50].id],
  status: i < 6 ? 'ON_DUTY' : 'OFF_DUTY',
}));

export const KPIS = {
  oee: 78.4,
  availability: 86.2,
  performance: 91.5,
  quality: 98.9,
  totalOutput: 12840,
  scrapRate: 1.8,
  mtbf: '42h',
  mttr: '1h 12m',
};

export const OUTPUT_TREND = [42, 55, 48, 63, 59, 72, 68, 80, 74, 88, 82, 95];
export const DOWNTIME_BREAKDOWN = [
  { reason: 'Mechanical', hours: 24, color: 'var(--kmt-red)' },
  { reason: 'Calibration', hours: 14, color: 'var(--kmt-amber)' },
  { reason: 'Material Wait', hours: 9, color: 'var(--kmt-blue)' },
  { reason: 'Changeover', hours: 6, color: 'var(--kmt-gold)' },
  { reason: 'Other', hours: 4, color: 'var(--kmt-idle)' },
];
